export class RoleDto{
    roleId:number;
    roleName:string;
    username:string;

    
    /**
     * 
     * @param roleId 
     * @param roleName 
     * @param username
     */
    constructor(roleId:number, roleName:string, username:string){

        this.roleId=roleId;
        this.roleName=roleName;
        this.username=username;

    }
}